// import { defaultNetworkService } from '../../../../../services/network'
import axios from "axios";
import { takeLatest, call, put, takeEvery, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../../utils/queryParams.js";
import moment from "moment";
export const SET_LOADING = "saga/SET_LOADING";
export const SET_GOALS_LOADING = "saga/SET_GOALS_LOADING";
export const SET_MESSAGES_LOADING = "saga/SET_MESSAGES_LOADING";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";
export const FETCH_MESSAGES = "saga/FETCH_MESSAGES";
export const FETCH_MESSAGES_SUCCESS = "saga/FETCH_MESSAGES_SUCCESS";

export const FETCH_NOTIFICATION_SUCCESS = "saga/FETCH_NOTIFICATION_SUCCESS";
export const ACCEPT_NOTIFICATION = "saga/FETCH_NOTIFICATION";

export const FETCH_MESSAGES_FAILURE = "saga/FETCH_MESSAGES_BREAKDOWN_FAILURE";
export const FETCH_GOALS = "saga/FETCH_GOALS";
export const FETCH_GOALS_SUCCESS = "saga/FETCH_GOALS_SUCCESS";
export const FETCH_GOALS_FAILURE = "saga/FETCH_GOALS_FAILURE";
export const UPDATE_GOAL = "saga/UPDATE_GOAL";
export const UPDATE_GOAL_SUCCESS = "saga/UPDATE_GOAL_SUCCESS";
export const UPDATE_GOAL_FAILURE = "saga/UPDATE_GOAL_FAILURE";
export const MODIFY_MESSAGE = "saga/MODIFY_MESSAGE";
export const MODIFY_MESSAGE_SUCCESS = "saga/MODIFY_MESSAGE_SUCCESS";
export const MODIFY_MESSAGE_FAILURE = "saga/MODIFY_MESSAGE_FAILURE";
export const PING_MESSAGES = "saga/PING_MESSAGES";
export const PING_MESSAGES_SUCCESS = "saga/PING_MESSAGES_SUCCESS";
export const PING_MESSAGES_FAILURE = "saga/PING_MESSAGES_FAILURE";
export const UPLOAD_IMAGE = "saga/UPLOAD_IMAGE";
export const UPLOAD_IMAGE_SUCCESS = "saga/UPLOAD_IMAGE_SUCCESS";
export const UPLOAD_IMAGE_FAILURE = "saga/UPLOAD_IMAGE_FAILURE";
export const IMAGE_UPLOADING = "saga/IMAGE_UPLOADING";
export const IMAGE_UPLOADING_SUCCESS = "saga/IMAGE_UPLOADING_SUCCESS";
export const IMAGE_UPLOADING_FAILURE = "saga/IMAGE_UPLOADING_FAILURE";
export const UPDATE_THEME_PREFERENCES = "saga/UPDATE_THEME_PREFERENCES";
export const UPDATE_THEME_PREFERENCES_SUCCESS = "saga/UPDATE_THEME_PREFERENCES_SUCCESS";
export const UPDATE_THEME_PREFERENCES_FAILURE = "saga/UPDATE_THEME_PREFERENCES_FAILURE";
export const UPDATE_TOS_PREFERENCES = "saga/UPDATE_TOS_PREFERENCES";
export const UPDATE_TOS_PREFERENCES_SUCCESS = "saga/UPDATE_TOS_PREFERENCES_SUCCESS";
export const UPDATE_TOS_PREFERENCES_FAILURE = "saga/UPDATE_THEME_PREFERENCES_FAILURE";
export const UPDATE_THEME_SUCCESS = "saga/UPDATE_THEME_SUCCESS";

// const axios = defaultNetworkService()

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  pingMessages: createAction(PING_MESSAGES),
  fetchMessages: createAction(FETCH_MESSAGES),
  fetchGoals: createAction(FETCH_GOALS),
  updateGoal: createAction(UPDATE_GOAL),
  modifyMessage: createAction(MODIFY_MESSAGE),
  uploadImage: createAction(UPLOAD_IMAGE),
  imageUploading: createAction(IMAGE_UPLOADING),
  updateThemePreferences: createAction(UPDATE_THEME_PREFERENCES),
  userAcceptTOS: createAction(UPDATE_TOS_PREFERENCES),
  acceptNotification: createAction(ACCEPT_NOTIFICATION)
};
export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(PING_MESSAGES, pingMessages);
  yield takeLatest(FETCH_GOALS, getGoals);
  yield takeLatest(UPDATE_GOAL, updateGoal);
  yield takeLatest(MODIFY_MESSAGE, modifyMessage);
  yield takeEvery(UPLOAD_IMAGE, uploadPhoto);
  yield takeLatest(IMAGE_UPLOADING, imageUploading);
  yield takeEvery(UPDATE_THEME_PREFERENCES, updateThemePreferences);
  yield takeEvery(UPDATE_TOS_PREFERENCES, userAcceptTOS);
  yield takeEvery(ACCEPT_NOTIFICATION, changeNotificationStatus);
}

export const { acceptNotification } = actionCreators;

export function* getCurrentUserData(data) {
  // Get user data first. Once we confirm we have user data pass to other sagas and call them.
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload });

  // let id = yield select(state => state.userMenu.currentUser.organization_id);
  // let objectId = yield select(state => state.userMenu.currentUser.current_mindbody_site_id);
  // let locationId = yield select(state => state.userMenu.currentUser.current_location_id);
  let allSagas = [getMessages];
  try {
    yield all(allSagas);
    yield getNotification();
  } catch (error) {
    console.error(error);
    yield put({ type: SET_MESSAGES_LOADING, payload: false });
  }
}

function* getNotification() {
  let organization_id = yield select((state) => state.userMenu.currentUser.organization_id);
  let {
    data: { notification = {} }
  } = yield call(axios.get, queryParams.apiVersion + "notifications", {
    params: { organization_id }
  });
  yield put({ type: FETCH_NOTIFICATION_SUCCESS, payload: notification });
}

function* changeNotificationStatus(data) {
  let user_id = yield select((state) => state.userMenu.currentUser.id);

  try {
    let { status } = yield call(axios.post, queryParams.apiVersion + "notifications", {
      notification: {
        notification_id: data.payload,
        user_id
      }
    });
    if (status == 200) {
      yield getNotification();
    }
  } catch (err) {
    console.error(err);
    yield put({ type: FETCH_NOTIFICATION_SUCCESS, payload: {} });
  }
}

export function* pingMessages() {
  // let id = yield select(state => state.userMenu.currentUser.organization_id);
  // let objectId = yield select(state => state.userMenu.currentUser.current_mindbody_site_id);
  // let locationId = yield select(state => state.userMenu.currentUser.current_location_id);
  let allSagas = [getMessages];
  try {
    yield all(allSagas);
  } catch (error) {
    console.error(error);
    yield put({ type: SET_MESSAGES_LOADING, payload: false });
  }
}

export function* updateGoal(data) {
  yield put({ type: SET_GOALS_LOADING, payload: true });
  try {
    const goalsResponse = yield call(
      axios.put,
      queryParams.apiVersion +
        "goals/" +
        data.payload.id +
        "?goalIncrease=" +
        data.payload.value +
        "&active=" +
        data.payload.active
    );
    yield put({ type: UPDATE_GOAL_SUCCESS, payload: goalsResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: UPDATE_GOAL_SUCCESS, error });
  }
}

export function* getGoals(payload) {
  // console.log('goals data', payload.payload)
  try {
    const goalsResponse = yield call(
      axios.get,
      queryParams.apiVersion +
        "goals/" +
        "?organization_id=" +
        payload.payload.id +
        "&location_id=" +
        payload.payload.locationId +
        "&object_id=" +
        payload.payload.objectId
    );
    yield put({ type: FETCH_GOALS_SUCCESS, payload: goalsResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_GOALS_SUCCESS, error });
  }
}

export function* getMessages() {
  try {
    const messagesResponse = yield call(axios.get, queryParams.apiVersion + "messages");
    yield put({ type: FETCH_MESSAGES_SUCCESS, payload: messagesResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_MESSAGES_SUCCESS, error });
  }
}

export function* modifyMessage(data) {
  // console.log(data.payload.deleMe)
  if (data.payload.deleMe) {
    yield put({ type: SET_MESSAGES_LOADING, payload: true });
  }
  try {
    const modifyResponse = yield call(
      axios.put,
      queryParams.apiVersion +
        "messages/" +
        data.payload.id +
        "?read=" +
        data.payload.markAsRead +
        "&deleted=" +
        data.payload.deleMe
    );
    yield put({ type: MODIFY_MESSAGE_SUCCESS, payload: modifyResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: MODIFY_MESSAGE_SUCCESS, error });
  }
}

export function* uploadPhoto(data) {
  try {
    const response = yield call(
      axios.put,
      queryParams.apiVersion +
        "users/" +
        data.payload.id +
        "?organization_id=" +
        data.payload.orgId,
      {
        avatar: data.payload.img
      }
    );
    yield put({ type: UPLOAD_IMAGE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: UPLOAD_IMAGE_FAILURE, error });
  }
}

export function* imageUploading(setting) {
  yield put({ type: IMAGE_UPLOADING_SUCCESS, payload: setting });
}

export function* updateThemePreferences(data) {
  yield put({ type: UPDATE_THEME_SUCCESS, payload: data.payload });
  try {
    const response = yield call(
      axios.put,
      queryParams.apiVersion + "base/set_default_dashboard_modules",
      {
        theme: data.payload
      }
    );

    yield put({ type: UPDATE_THEME_PREFERENCES_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: UPDATE_THEME_PREFERENCES_FAILURE, error });
  }
}

export function* userAcceptTOS(userID) {
  let id = yield select((state) => state.userMenu.currentUser.organization_id);
  let siteId = yield select((state) => state.userMenu.currentUser.current_mindbody_site_id);
  let locationId = yield select((state) => state.userMenu.currentUser.current_location_id);

  try {
    const response = yield call(
      axios.put,
      queryParams.apiVersion +
        "users/" +
        userID.payload +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&mindbody_site_id=" +
        siteId +
        "&accepted_tos_at=" +
        moment().format("YYYY-MM-DD")
    );

    yield put({ type: UPDATE_TOS_PREFERENCES_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: UPDATE_TOS_PREFERENCES_FAILURE, error });
  }
}
